import { styled } from "@mui/material/styles";

const SingleImageWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  height: "140px",
  borderRadius: "12px",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  overflow: "hidden",
  marginBottom: "5px",
}));
const MultipleImages = styled("div")(({ theme }) => ({
  "&.receiver_Images": { justifyContent: "start" },
  display: "flex",
  flexWrap: "wrap",
  marginTop: "10px",
  justifyContent: "end",

  "& .ImageWrapper:nth-child(2)": {
    marginRight: "0px",
  },
  "& .ImageWrapper:nth-child(4)": {
    marginRight: "0px",
  },
}));
const ImageWrapper = styled("div")(({ theme }) => ({
  width: "104px",
  height: "104px",
  marginRight: "10px",
  marginBottom: "5px",
  position: "relative",
}));
const MultipleImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "16px 16px 16px 0px",
}));
const MoreImagesCount = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: "0",
  right: "0",
  padding: "4px",
  width: "104px",
  height: "104px",
  background: "rgba(1, 1, 1, 0.5)",
  borderRadius: "16px 16px 16px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "20px",
  color: "#FFFFFF",
}));
// ===== sender and recive message message design  ===

const MessaageMain = styled("div")(({ theme }) => ({
  "&.reciver_message_main": { alignSelf: "flex-start" },
  "&.sender_message_main": { alignSelf: "flex-end", marginLeft: "auto" },

  maxWidth: "30%",
  position: "relative",
  wordWrap: "break-word",
  [theme.breakpoints.down("lg")]: {
    maxWidth: "80%",
  },
  "& #ReactSimpleImageViewer": {
    zIndex: "9999",
  },
  "& .react-simple-image-viewer__close": {
    fontSize: "33px ",
    fontWeight: 500,
  },
  "& .react-simple-image-viewer__next": {
    fontSize: "33px ",
    fontWeight: 500,
  },
  "& .react-simple-image-viewer__previous": {
    fontSize: "33px ",
    fontWeight: 500,
  },
}));

const MessageText = styled("p")(({ theme }) => ({
  "&.reciver_message_text": { background: "#D9D9D9", color: "#0B0B0B" },
  "&.sender_message_text": { background: "#0B0B0B", color: "#fff" },
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "19px",
  color: "#0B0B0B",
  padding: "10px",
  background: "#D9D9D9",
  borderRadius: "12px",
  fontFamily: theme.typography.fontFamily,
}));

const MessageAction = styled("div")(({ theme }) => ({
  "&.reciver_message_action": { justifyContent: "start" },
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  gap: "10px",
  marginTop: "5px",
  "& svg": {
    fontSize: "16px",
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "rgba(11, 11, 11, 0.6)",
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
  },
}));

// ===== End sender and recive message message design  ===

export {
  SingleImageWrapper,
  MultipleImages,
  ImageWrapper,
  MultipleImage,
  MoreImagesCount,
  MessaageMain,
  MessageText,
  MessageAction,
};
